"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailBuyButton = void 0;
const react_1 = __importDefault(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const styles_1 = require("./styles");
const RetailBuyButton = ({ callToActionCheckout, quantity }) => {
    var _a, _b, _c;
    const [configStore] = (0, monera_app_core_1.useConfigStore)();
    const asin = configStore.asin;
    return callToActionCheckout != undefined && callToActionCheckout.checkout != undefined ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.StyledForm, { action: (_a = callToActionCheckout === null || callToActionCheckout === void 0 ? void 0 : callToActionCheckout.checkout) === null || _a === void 0 ? void 0 : _a.url, method: "post" }, (_b = callToActionCheckout === null || callToActionCheckout === void 0 ? void 0 : callToActionCheckout.checkout) === null || _b === void 0 ? void 0 :
            _b.data.parameters.map(({ name, value }) => {
                return react_1.default.createElement("input", { key: name, type: "hidden", name: name, id: name, value: value });
            }),
            react_1.default.createElement("input", { type: "hidden", name: 'quantity', id: 'quantity', value: quantity }),
            react_1.default.createElement("input", { type: "hidden", name: 'buyNow', id: 'buyNow', value: quantity }),
            react_1.default.createElement("input", { type: "hidden", name: 'asin', id: 'asin', value: asin }),
            react_1.default.createElement(styles_1.FullWidthButton, { buttonType: "buyNow", type: "submit" }, (_c = callToActionCheckout === null || callToActionCheckout === void 0 ? void 0 : callToActionCheckout.checkout) === null || _c === void 0 ? void 0 : _c.data.displayString)))) : null;
};
exports.RetailBuyButton = RetailBuyButton;
